import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Typography,
  FormHelperText,
} from "@mui/material";
import { distanceUnits } from "../../utils/distanceUnits";
import { weightUnits } from "../../utils/weightUnits";
import CustomTypography from "../../globalStyles/fonts";

const DimensionsAndWeightInputWithUnit = ({
  onChange,
  dimensions,
  weight,
  dimensionUnitValue,
  weightUnitValue,
  requiredField,
  disabled = false,
  showOnlyUnitInput,
  showOnlyWeightUnit,
  showOnlyDimensionUnit,
  sm,
  error,
}) => {
  const [dimensionUnitData, setDimensionUnitData] = useState([]);
  const [weightUnitData, setWeightUnitData] = useState([]);

  useEffect(() => {
    setDimensionUnitData(distanceUnits);
    setWeightUnitData(weightUnits);
  }, []);

  const handleChange = (field, value) => {
    onChange({ field: field, value: value });
  };

  return (
    <div style={{ width: "100%" }}>
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        {/* Height, Width, Length Fields */}
        {showOnlyUnitInput ? (
          <></>
        ) : (
          ["Height", "Width", "Length"].map((dim) => (
            <Grid item xs={12} sm={4} md={2} key={dim}>
              <CustomTypography
                fontSize="14px"
                textAlign={"left"}
                fontFamily="poppins"
                fontWeight={400}
              >
                {dim} {requiredField && <span style={{ color: "red" }}>*</span>}
              </CustomTypography>
              <TextField
                sx={{
                  backgroundColor: "var(--bg-paper)",
                  "& .MuiFormHelperText-root": {
                    minHeight: "20px",
                    marginTop: "4px",
                  },
                }}
                size="small"
                placeholder={`Enter ${dim}`}
                type="number"
                value={dimensions[dim.toLowerCase()]}
                onChange={(e) =>
                  handleChange(dim.toLowerCase(), e.target.value)
                }
                fullWidth
                margin="dense"
                inputProps={{ min: 0 }}
                disabled={disabled}
                style={
                  disabled
                    ? {
                        color: "var(--text-primary)",
                        backgroundColor: "var(--bg-input)",
                      }
                    : {}
                }
                error={error && error[dim.toLowerCase()]}
                helperText={
                  error && error[dim.toLowerCase()]
                    ? error[dim.toLowerCase()]
                    : " "
                }
              />
            </Grid>
          ))
        )}

        {/* Dimension Unit */}
        {showOnlyWeightUnit ? (
          <></>
        ) : (
          <Grid item xs={12} sm={sm ? sm : 2}>
            <CustomTypography
              fontSize="14px"
              textAlign={"left"}
              fontFamily="poppins"
              fontWeight={400}
            >
              Dimension Unit{" "}
              {requiredField && <span style={{ color: "red" }}>*</span>}
            </CustomTypography>
            <FormControl
              sx={{
                backgroundColor: "var(--bg-paper)",
                minHeight: "56px",
                marginTop: "8px",
                marginBottom: "4px",
              }}
              fullWidth
              size="small"
              error={!!(error && error["dimension_unit"])}
            >
              <Select
                disabled={disabled}
                value={dimensionUnitValue}
                onChange={(e) => handleChange("dimension_unit", e.target.value)}
                style={
                  disabled
                    ? {
                        color: "var(--text-primary)",
                        backgroundColor: "var(--bg-input)",
                      }
                    : {}
                }
              >
                {dimensionUnitData.map((x) => (
                  <MenuItem key={x.abbreviation} value={x.abbreviation}>
                    {x.abbreviation}
                  </MenuItem>
                ))}
              </Select>
              {error && error["dimension_unit"] && (
                <FormHelperText>{error["dimension_unit"]}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        )}

        {/* Weight Field */}
        {showOnlyUnitInput ? (
          <></>
        ) : (
          <Grid item xs={12} sm={sm ? sm : 2}>
            <CustomTypography
              fontSize="14px"
              textAlign={"left"}
              fontFamily="poppins"
              fontWeight={400}
            >
              Weight {requiredField && <span style={{ color: "red" }}>*</span>}
            </CustomTypography>
            <TextField
              sx={{
                backgroundColor: "var(--bg-paper)",
                "& .MuiFormHelperText-root": {
                  minHeight: "20px",
                  marginTop: "4px",
                },
              }}
              size="small"
              placeholder="Enter Weight"
              type="number"
              value={weight}
              onChange={(e) => handleChange("weight", e.target.value)}
              fullWidth
              margin="dense"
              inputProps={{ min: 0 }}
              disabled={disabled}
              style={
                disabled
                  ? {
                      color: "var(--text-primary)",
                      backgroundColor: "var(--bg-input)",
                    }
                  : {}
              }
              error={!!error && !!error["weight"]}
              helperText={error && error["weight"] ? error["weight"] : " "}
            />
          </Grid>
        )}

        {/* Weight Unit */}
        {showOnlyDimensionUnit ? (
          <></>
        ) : (
          <Grid item xs={12} sm={sm ? sm : 2}>
            <CustomTypography
              fontSize="14px"
              textAlign={"left"}
              fontFamily="poppins"
              fontWeight={400}
            >
              Weight Unit{" "}
              {requiredField && <span style={{ color: "red" }}>*</span>}
            </CustomTypography>
            <FormControl
              sx={{
                backgroundColor: "var(--bg-paper)",
                minHeight: "56px",
                marginTop: "8px",
                marginBottom: "4px",
              }}
              fullWidth
              size="small"
              error={!!(error && error["weight_unit"])}
            >
              <Select
                disabled={disabled}
                value={weightUnitValue}
                onChange={(e) => handleChange("weight_unit", e.target.value)}
                style={
                  disabled
                    ? {
                        color: "var(--text-primary)",
                        backgroundColor: "var(--bg-input)",
                      }
                    : {}
                }
              >
                {weightUnitData.map((x) => (
                  <MenuItem key={x.abbreviation} value={x.abbreviation}>
                    {x.abbreviation}
                  </MenuItem>
                ))}
              </Select>
              {error && error["weight_unit"] && (
                <FormHelperText>{error["weight_unit"]}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default DimensionsAndWeightInputWithUnit;
